export { DENSITY_ELEMENT_VARS, DENSITY_SPACING_VARS, DIAGRAM_VARS, ELEVATION_VARS, GEOMETRY_VARS, ICONOGRAPHY_VARS, LEGACY_PREFIXES, MOTION_DURATION_KEYS, MOTION_EASING_KEYS, MOTION_INTENT_VARS, MOTION_SHAPE_VARS, SCENE_VARS, SURFACE_VARS, TYPE_FAMILY_VARS, TYPE_HEADING_VARS, TYPE_INTENT_VARS, TYPE_SIZE_KEYS, enterKeyframe, resolveThemeForRuntime, themeTokensToCssVars } from '../chunk-ZR45FGW3.js';
export { EDITOR_MOTIONS, EDITOR_OPERATORS, ENTER_SLOT_CLASS, INDENT_UNIT, MAX_ENTER_DELAY, PERF_NAMESPACE, applyMotion, applyOperator, arrowheadPath, asEnterAnimation, brainIconPath, clearDebugEvents, clearEntityProvider, clearGuardHistory, clearPerf, clearTicks, clearTraits, computeLineDiff, debug, debugCollision, debugError, debugGameState, debugGroup, debugGroupEnd, debugInput, debugPhysics, debugTable, debugTime, debugTimeEnd, debugWarn, eightPointedStarPath, enterClassName, gearTeethPath, getAllTicks, getAllTraits, getDebugEvents, getEntitiesByType, getEntityById, getEntitySnapshot, getEventsBySource, getEventsByType, getGuardEvaluationsForTrait, getGuardHistory, getNestedValue, getRecentEvents, getRecentGuardEvaluations, getTick, getTrait, initDebugShortcut, isDebugEnabled, isEditorMotion, isEditorOperator, lockIconPath, logDebugEvent, logEffectExecuted, logError, logEventFired, logInfo, logStateChange, logWarning, motionRange, onDebugToggle, parseContentSegments, parseLessonSegments, parseMarkdownWithCodeBlocks2 as parseMarkdownWithCodeBlocks, perfEnd, perfGauge, perfStart, perfTime, perfTimeAsync, pipeIconPath, profilerOnRender, recordGuardEvaluation, registerTick, registerTrait, resolveImageUrl, setDebugEnabled, setEntityProvider, setTickActive, subscribeToDebugEvents, subscribeToGuardChanges, subscribeToTickChanges, subscribeToTraitChanges, toggleDebug, unregisterTick, unregisterTrait, updateGuardResult, updateTickExecution, updateTraitState, usePerfBuffer } from '../chunk-N4IJS5DD.js';
export { bindCanvasCapture, bindConfigApplier, bindEventBus, bindLastDrawables, bindTraitStateGetter, clearVerification, getAllChecks, getBridgeHealth, getSnapshot, getSummary, getTraitSnapshots, getTransitions, getTransitionsForTrait, isEditableTarget, keyMapCode, recordOrbitalResponse, recordServerResponse, recordTransition, recordingTransport, registerCheck, registerTraitSnapshot, resolveKeyMapEvent, serverEffectTraces, subscribeToVerification, updateAssetStatus, updateBridgeHealth, updateCheck, waitForTransition } from '../chunk-N23SVGTH.js';
export { cn } from '../chunk-64WACXM7.js';
export { DEFAULT_CURRENCY, compareCellValues, formatDate, formatDateTime, formatTime, formatValue, parseCalendarDate, sortRows, toDateInputValue, toDateTimeInputValue } from '../chunk-6ZCU3BQN.js';
import '../chunk-FYX64CDL.js';
import { __publicField } from '../chunk-QPXIAUJD.js';

// lib/api-client.ts
var API_BASE_URL = typeof process !== "undefined" && process.env?.VITE_API_URL ? process.env.VITE_API_URL : "/api";
var ApiError = class extends Error {
  constructor(status, statusText, message) {
    super(message || `API Error: ${status} ${statusText}`);
    __publicField(this, "status", status);
    __publicField(this, "statusText", statusText);
    this.name = "ApiError";
  }
};
async function handleResponse(response) {
  if (!response.ok) {
    let message;
    try {
      const errorData = await response.json();
      message = errorData.message || errorData.error;
    } catch {
    }
    throw new ApiError(response.status, response.statusText, message);
  }
  const text = await response.text();
  if (!text) {
    return void 0;
  }
  return JSON.parse(text);
}
function getHeaders() {
  const headers = {
    "Content-Type": "application/json"
  };
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("authToken") : null;
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
}
var apiClient = {
  /**
   * GET request
   */
  async get(endpoint) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: "GET",
      headers: getHeaders()
    });
    return handleResponse(response);
  },
  /**
   * POST request
   */
  async post(endpoint, data) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: "POST",
      headers: getHeaders(),
      body: data ? JSON.stringify(data) : void 0
    });
    return handleResponse(response);
  },
  /**
   * PUT request
   */
  async put(endpoint, data) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: "PUT",
      headers: getHeaders(),
      body: data ? JSON.stringify(data) : void 0
    });
    return handleResponse(response);
  },
  /**
   * PATCH request
   */
  async patch(endpoint, data) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: "PATCH",
      headers: getHeaders(),
      body: data ? JSON.stringify(data) : void 0
    });
    return handleResponse(response);
  },
  /**
   * DELETE request
   */
  async delete(endpoint) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: "DELETE",
      headers: getHeaders()
    });
    return handleResponse(response);
  }
};

// lib/command-send-pump.ts
function createCommandSendPump() {
  let tail = Promise.resolve();
  return {
    enqueue(job) {
      const result = tail.then(job);
      tail = result.then(
        () => void 0,
        () => void 0
      );
      return result;
    }
  };
}

// lib/jazari/layout.ts
var GEAR_RADIUS = 35;
var GEAR_SPACING = 130;
var PADDING_X = 80;
var PADDING_Y = 120;
var ARC_HEIGHT = 70;
var SELF_LOOP_RADIUS = 30;
var PARALLEL_OFFSET = 24;
function orderStates(states, transitions) {
  const initial = states.find((s) => s.isInitial);
  if (!initial) {
    return states.map((s) => s.name);
  }
  const adj = /* @__PURE__ */ new Map();
  for (const t of transitions) {
    const existing = adj.get(t.from) ?? [];
    existing.push(t.to);
    adj.set(t.from, existing);
  }
  const visited = /* @__PURE__ */ new Set();
  const order = [];
  const queue = [initial.name];
  visited.add(initial.name);
  while (queue.length > 0) {
    const current = queue.shift();
    order.push(current);
    const neighbors = adj.get(current) ?? [];
    for (const next of neighbors) {
      if (!visited.has(next)) {
        visited.add(next);
        queue.push(next);
      }
    }
  }
  for (const s of states) {
    if (!visited.has(s.name)) {
      order.push(s.name);
    }
  }
  return order;
}
function quadBezierPoint(x0, y0, cx, cy, x1, y1, t) {
  const mt = 1 - t;
  return {
    x: mt * mt * x0 + 2 * mt * t * cx + t * t * x1,
    y: mt * mt * y0 + 2 * mt * t * cy + t * t * y1
  };
}
function computeJazariLayout(input) {
  const { states, transitions, entityFields = [], direction = "ltr" } = input;
  if (states.length === 0) {
    return {
      width: 200,
      height: 200,
      gears: [],
      arms: [],
      axisY: 100,
      axisStartX: 0,
      axisEndX: 200,
      entityFields,
      direction
    };
  }
  const stateOrder = orderStates(states, transitions);
  const stateMap = new Map(states.map((s) => [s.name, s]));
  const stateIndex = new Map(stateOrder.map((name, i) => [name, i]));
  const totalWidth = PADDING_X * 2 + (stateOrder.length - 1) * GEAR_SPACING;
  const axisY = PADDING_Y + ARC_HEIGHT + SELF_LOOP_RADIUS + 10;
  const height = axisY + PADDING_Y + ARC_HEIGHT + SELF_LOOP_RADIUS + 10;
  const gears = stateOrder.map((name, i) => {
    const state = stateMap.get(name);
    const xPos = direction === "rtl" ? totalWidth - PADDING_X - i * GEAR_SPACING : PADDING_X + i * GEAR_SPACING;
    return {
      name,
      cx: xPos,
      cy: axisY,
      radius: GEAR_RADIUS,
      isInitial: state?.isInitial === true,
      isTerminal: state?.isTerminal === true || state?.isFinal === true
    };
  });
  const pairCounts = /* @__PURE__ */ new Map();
  const pairIndices = /* @__PURE__ */ new Map();
  for (const t of transitions) {
    const pairKey = `${t.from}|${t.to}`;
    pairCounts.set(pairKey, (pairCounts.get(pairKey) ?? 0) + 1);
  }
  const arms = transitions.map((t) => {
    const pairKey = `${t.from}|${t.to}`;
    const currentIdx = pairIndices.get(pairKey) ?? 0;
    pairIndices.set(pairKey, currentIdx + 1);
    const pairCount = pairCounts.get(pairKey) ?? 1;
    const parallelShift = (currentIdx - (pairCount - 1) / 2) * PARALLEL_OFFSET;
    const fromIdx = stateIndex.get(t.from) ?? 0;
    const toIdx = stateIndex.get(t.to) ?? 0;
    const fromGear = gears[fromIdx];
    const toGear = gears[toIdx];
    if (!fromGear || !toGear) {
      return {
        from: t.from,
        to: t.to,
        event: t.event,
        path: "",
        labelX: 0,
        labelY: 0,
        guard: null,
        effect: null,
        isSelfLoop: false
      };
    }
    const isSelfLoop = t.from === t.to;
    let path;
    let labelX;
    let labelY;
    let ctrlX;
    let ctrlY;
    if (isSelfLoop) {
      const loopY = fromGear.cy - GEAR_RADIUS - SELF_LOOP_RADIUS - 5;
      path = [
        `M ${fromGear.cx - 12} ${fromGear.cy - GEAR_RADIUS}`,
        `C ${fromGear.cx - 25} ${loopY - 15}, ${fromGear.cx + 25} ${loopY - 15}, ${fromGear.cx + 12} ${fromGear.cy - GEAR_RADIUS}`
      ].join(" ");
      labelX = fromGear.cx;
      labelY = loopY - 10;
      ctrlX = fromGear.cx;
      ctrlY = loopY;
    } else {
      const isForward = direction === "rtl" ? fromIdx > toIdx : fromIdx < toIdx;
      const arcSign = isForward ? -1 : 1;
      const midX = (fromGear.cx + toGear.cx) / 2;
      ctrlY = axisY + arcSign * (ARC_HEIGHT + Math.abs(parallelShift));
      ctrlX = midX;
      const perimeterR = GEAR_RADIUS + 7;
      const dx = toGear.cx - fromGear.cx;
      const dy = toGear.cy - fromGear.cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const startX = dist > 0 ? fromGear.cx + dx / dist * perimeterR : fromGear.cx;
      const startY = dist > 0 ? fromGear.cy + dy / dist * perimeterR : fromGear.cy;
      const endX = dist > 0 ? toGear.cx - dx / dist * perimeterR : toGear.cx;
      const endY = dist > 0 ? toGear.cy - dy / dist * perimeterR : toGear.cy;
      path = `M ${startX} ${startY} Q ${ctrlX} ${ctrlY} ${endX} ${endY}`;
      const mid = quadBezierPoint(startX, startY, ctrlX, ctrlY, endX, endY, 0.5);
      labelX = mid.x;
      labelY = mid.y;
    }
    let guard = null;
    if (t.guard != null) {
      const isAI = Array.isArray(t.guard) && typeof t.guard[0] === "string" && t.guard[0] === "call-service";
      if (isSelfLoop) {
        guard = { x: fromGear.cx - 18, y: fromGear.cy - GEAR_RADIUS - SELF_LOOP_RADIUS, isAI };
      } else {
        const gp = quadBezierPoint(fromGear.cx, fromGear.cy, ctrlX, ctrlY, toGear.cx, toGear.cy, 0.3);
        guard = { x: gp.x, y: gp.y, isAI };
      }
    }
    let effect = null;
    if (t.effects && t.effects.length > 0) {
      const names = t.effects.map((e) => {
        if (Array.isArray(e)) return JSON.stringify(e);
        return String(e);
      });
      if (isSelfLoop) {
        effect = { x: fromGear.cx + 18, y: fromGear.cy - GEAR_RADIUS - SELF_LOOP_RADIUS, count: t.effects.length, names };
      } else {
        const ep = quadBezierPoint(fromGear.cx, fromGear.cy, ctrlX, ctrlY, toGear.cx, toGear.cy, 0.7);
        effect = { x: ep.x, y: ep.y, count: t.effects.length, names };
      }
    }
    return {
      from: t.from,
      to: t.to,
      event: t.event,
      path,
      labelX,
      labelY,
      guard,
      effect,
      isSelfLoop
    };
  });
  return {
    width: totalWidth,
    height,
    gears,
    arms,
    axisY,
    axisStartX: direction === "rtl" ? gears[gears.length - 1]?.cx ?? PADDING_X : gears[0]?.cx ?? PADDING_X,
    axisEndX: direction === "rtl" ? gears[0]?.cx ?? totalWidth - PADDING_X : gears[gears.length - 1]?.cx ?? totalWidth - PADDING_X,
    entityFields,
    direction
  };
}

// lib/jazari/types.ts
var JAZARI_COLORS = {
  brass: "#B87333",
  gold: "#C8A951",
  sky: "#0EA5E9",
  crimson: "#DC2626",
  lapis: "#1E40AF",
  ivory: "#FFFBEB",
  darkBg: "#1a1a2e"
};

// lib/iconNativeMap.ts
var ICON_FALLBACK = {
  sfSymbol: "questionmark.circle",
  materialSymbol: "help"
};
var ICON_NATIVE_MAP = {
  // --- navigation & chrome ---
  "home": { sfSymbol: "house", materialSymbol: "home" },
  "menu": { sfSymbol: "line.3.horizontal", materialSymbol: "menu" },
  "more-horizontal": { sfSymbol: "ellipsis", materialSymbol: "more_horiz" },
  "more-vertical": { sfSymbol: "ellipsis", materialSymbol: "more_vert" },
  "chevron-right": { sfSymbol: "chevron.right", materialSymbol: "chevron_right" },
  "chevron-left": { sfSymbol: "chevron.left", materialSymbol: "chevron_left" },
  "chevron-up": { sfSymbol: "chevron.up", materialSymbol: "keyboard_arrow_up" },
  "chevron-down": { sfSymbol: "chevron.down", materialSymbol: "keyboard_arrow_down" },
  "chevrons-left": { sfSymbol: "chevron.left.2", materialSymbol: "keyboard_double_arrow_left" },
  "chevrons-right": { sfSymbol: "chevron.right.2", materialSymbol: "keyboard_double_arrow_right" },
  "chevrons-up-down": { sfSymbol: "chevron.up.chevron.down", materialSymbol: "unfold_more" },
  "arrow-left": { sfSymbol: "arrow.left", materialSymbol: "arrow_back" },
  "arrow-right": { sfSymbol: "arrow.right", materialSymbol: "arrow_forward" },
  "arrow-up": { sfSymbol: "arrow.up", materialSymbol: "arrow_upward" },
  "arrow-down": { sfSymbol: "arrow.down", materialSymbol: "arrow_downward" },
  "arrow-up-right": { sfSymbol: "arrow.up.right", materialSymbol: "north_east" },
  "arrow-down-left": { sfSymbol: "arrow.down.left", materialSymbol: "south_west" },
  "corner-up-left": { sfSymbol: "arrow.turn.up.left", materialSymbol: "subdirectory_arrow_left" },
  "corner-down-right": { sfSymbol: "arrow.turn.down.right", materialSymbol: "subdirectory_arrow_right" },
  "external-link": { sfSymbol: "arrow.up.forward.square", materialSymbol: "open_in_new" },
  "log-out": { sfSymbol: "rectangle.portrait.and.arrow.right", materialSymbol: "logout" },
  "log-in": { sfSymbol: "arrow.right.square", materialSymbol: "login" },
  // `left_panel_open`/`right_panel_open` (Material Symbols) have no
  // `Icons.Filled.*` member in androidx `material-icons-extended` (a newer
  // Material-Symbols-only pair) — `first_page`/`last_page` are the closest
  // directional stand-ins that actually compile (verified wave C5).
  "panel-left": { sfSymbol: "sidebar.left", materialSymbol: "first_page" },
  "panel-right": { sfSymbol: "sidebar.right", materialSymbol: "last_page" },
  "sidebar": { sfSymbol: "sidebar.left", materialSymbol: "view_sidebar" },
  "layout-grid": { sfSymbol: "square.grid.2x2", materialSymbol: "grid_view" },
  "layout-list": { sfSymbol: "list.bullet", materialSymbol: "view_list" },
  "grid": { sfSymbol: "square.grid.2x2", materialSymbol: "grid_view" },
  "list": { sfSymbol: "list.bullet", materialSymbol: "list" },
  // --- actions ---
  "plus": { sfSymbol: "plus", materialSymbol: "add" },
  "plus-circle": { sfSymbol: "plus.circle", materialSymbol: "add_circle" },
  "minus": { sfSymbol: "minus", materialSymbol: "remove" },
  "minus-circle": { sfSymbol: "minus.circle", materialSymbol: "remove_circle" },
  "x": { sfSymbol: "xmark", materialSymbol: "close" },
  "close": { sfSymbol: "xmark", materialSymbol: "close" },
  "check": { sfSymbol: "checkmark", materialSymbol: "check" },
  "check-circle": { sfSymbol: "checkmark.circle", materialSymbol: "check_circle" },
  "circle-check": { sfSymbol: "checkmark.circle", materialSymbol: "check_circle" },
  "check-square": { sfSymbol: "checkmark.square", materialSymbol: "check_box" },
  "x-circle": { sfSymbol: "xmark.circle", materialSymbol: "cancel" },
  "trash": { sfSymbol: "trash", materialSymbol: "delete" },
  "trash-2": { sfSymbol: "trash", materialSymbol: "delete" },
  "edit": { sfSymbol: "pencil", materialSymbol: "edit" },
  "edit-2": { sfSymbol: "pencil", materialSymbol: "edit" },
  "edit-3": { sfSymbol: "pencil", materialSymbol: "edit" },
  "pencil": { sfSymbol: "pencil", materialSymbol: "edit" },
  "copy": { sfSymbol: "doc.on.doc", materialSymbol: "content_copy" },
  "clipboard": { sfSymbol: "clipboard", materialSymbol: "content_paste" },
  "save": { sfSymbol: "square.and.arrow.down", materialSymbol: "save" },
  "download": { sfSymbol: "arrow.down.circle", materialSymbol: "download" },
  "upload": { sfSymbol: "arrow.up.circle", materialSymbol: "upload" },
  "share": { sfSymbol: "square.and.arrow.up", materialSymbol: "share" },
  "share-2": { sfSymbol: "square.and.arrow.up", materialSymbol: "share" },
  "refresh-cw": { sfSymbol: "arrow.clockwise", materialSymbol: "refresh" },
  "refresh": { sfSymbol: "arrow.clockwise", materialSymbol: "refresh" },
  "rotate-cw": { sfSymbol: "arrow.clockwise", materialSymbol: "rotate_right" },
  "rotate-ccw": { sfSymbol: "arrow.counterclockwise", materialSymbol: "rotate_left" },
  "undo": { sfSymbol: "arrow.uturn.backward", materialSymbol: "undo" },
  "redo": { sfSymbol: "arrow.uturn.forward", materialSymbol: "redo" },
  "filter": { sfSymbol: "line.3.horizontal.decrease.circle", materialSymbol: "filter_list" },
  "sliders": { sfSymbol: "slider.horizontal.3", materialSymbol: "tune" },
  "search": { sfSymbol: "magnifyingglass", materialSymbol: "search" },
  "zoom-in": { sfSymbol: "plus.magnifyingglass", materialSymbol: "zoom_in" },
  "zoom-out": { sfSymbol: "minus.magnifyingglass", materialSymbol: "zoom_out" },
  "settings": { sfSymbol: "gearshape", materialSymbol: "settings" },
  "lock": { sfSymbol: "lock", materialSymbol: "lock" },
  "unlock": { sfSymbol: "lock.open", materialSymbol: "lock_open" },
  "eye": { sfSymbol: "eye", materialSymbol: "visibility" },
  "eye-off": { sfSymbol: "eye.slash", materialSymbol: "visibility_off" },
  "link": { sfSymbol: "link", materialSymbol: "link" },
  "link-2": { sfSymbol: "link", materialSymbol: "link" },
  "send": { sfSymbol: "paperplane", materialSymbol: "send" },
  "power": { sfSymbol: "power", materialSymbol: "power_settings_new" },
  "scissors": { sfSymbol: "scissors", materialSymbol: "content_cut" },
  // `ink_eraser` has no `Icons.Filled.*` member in androidx
  // `material-icons-extended` (newer Material-Symbols-only) — `backspace`
  // is the closest "erase" glyph that actually compiles (verified wave C5).
  "eraser": { sfSymbol: "eraser", materialSymbol: "backspace" },
  "stop": { sfSymbol: "stop.fill", materialSymbol: "stop" },
  "sort-asc": { sfSymbol: "arrow.up", materialSymbol: "arrow_upward" },
  "sort-desc": { sfSymbol: "arrow.down", materialSymbol: "arrow_downward" },
  // --- files ---
  "file": { sfSymbol: "doc", materialSymbol: "description" },
  "file-text": { sfSymbol: "doc.text", materialSymbol: "description" },
  "file-plus": { sfSymbol: "doc.badge.plus", materialSymbol: "note_add" },
  "file-minus": { sfSymbol: "doc.badge.minus", materialSymbol: "note" },
  "file-code": { sfSymbol: "chevron.left.forwardslash.chevron.right", materialSymbol: "code" },
  "file-json": { sfSymbol: "curlybraces", materialSymbol: "data_object" },
  "file-warning": { sfSymbol: "exclamationmark.triangle", materialSymbol: "warning" },
  "folder": { sfSymbol: "folder", materialSymbol: "folder" },
  "folder-open": { sfSymbol: "folder", materialSymbol: "folder_open" },
  "paperclip": { sfSymbol: "paperclip", materialSymbol: "attach_file" },
  "image": { sfSymbol: "photo", materialSymbol: "image" },
  "archive": { sfSymbol: "archivebox", materialSymbol: "archive" },
  "printer": { sfSymbol: "printer", materialSymbol: "print" },
  "book": { sfSymbol: "book", materialSymbol: "menu_book" },
  "bookmark": { sfSymbol: "bookmark", materialSymbol: "bookmark" },
  // --- communication ---
  "mail": { sfSymbol: "envelope", materialSymbol: "mail" },
  "inbox": { sfSymbol: "tray", materialSymbol: "inbox" },
  "message-circle": { sfSymbol: "bubble.left", materialSymbol: "chat_bubble" },
  "message-square": { sfSymbol: "bubble.left", materialSymbol: "forum" },
  "phone": { sfSymbol: "phone", materialSymbol: "call" },
  "bell": { sfSymbol: "bell", materialSymbol: "notifications" },
  "bell-off": { sfSymbol: "bell.slash", materialSymbol: "notifications_off" },
  "user": { sfSymbol: "person", materialSymbol: "person" },
  "users": { sfSymbol: "person.2", materialSymbol: "group" },
  "user-plus": { sfSymbol: "person.badge.plus", materialSymbol: "person_add" },
  "user-circle": { sfSymbol: "person.crop.circle", materialSymbol: "account_circle" },
  // --- status ---
  "info": { sfSymbol: "info.circle", materialSymbol: "info" },
  "alert-circle": { sfSymbol: "exclamationmark.circle", materialSymbol: "error" },
  "alert-triangle": { sfSymbol: "exclamationmark.triangle", materialSymbol: "warning" },
  "help-circle": { sfSymbol: "questionmark.circle", materialSymbol: "help" },
  "star": { sfSymbol: "star", materialSymbol: "star" },
  "star-half": { sfSymbol: "star.leadinghalf.filled", materialSymbol: "star_half" },
  "heart": { sfSymbol: "heart", materialSymbol: "favorite" },
  "flag": { sfSymbol: "flag", materialSymbol: "flag" },
  "tag": { sfSymbol: "tag", materialSymbol: "label" },
  "clock": { sfSymbol: "clock", materialSymbol: "schedule" },
  "calendar": { sfSymbol: "calendar", materialSymbol: "calendar_month" },
  // `progress_activity` has no `Icons.Filled.*` member in androidx
  // `material-icons-extended` (newer Material-Symbols-only) — `autorenew`
  // is the closest spinner/loading glyph that actually compiles (verified
  // wave C5).
  "loader": { sfSymbol: "arrow.triangle.2.circlepath", materialSymbol: "autorenew" },
  "loader-2": { sfSymbol: "arrow.triangle.2.circlepath", materialSymbol: "autorenew" },
  "activity": { sfSymbol: "waveform.path.ecg", materialSymbol: "monitor_heart" },
  "smile": { sfSymbol: "face.smiling", materialSymbol: "sentiment_satisfied" },
  // --- media ---
  "play": { sfSymbol: "play.fill", materialSymbol: "play_arrow" },
  "pause": { sfSymbol: "pause.fill", materialSymbol: "pause" },
  "skip-forward": { sfSymbol: "forward.fill", materialSymbol: "skip_next" },
  "skip-back": { sfSymbol: "backward.fill", materialSymbol: "skip_previous" },
  "volume-2": { sfSymbol: "speaker.wave.2", materialSymbol: "volume_up" },
  "volume": { sfSymbol: "speaker.wave.2", materialSymbol: "volume_up" },
  "volume-x": { sfSymbol: "speaker.slash", materialSymbol: "volume_off" },
  "volume-off": { sfSymbol: "speaker.slash", materialSymbol: "volume_off" },
  "camera": { sfSymbol: "camera", materialSymbol: "photo_camera" },
  "mic": { sfSymbol: "mic", materialSymbol: "mic" },
  "video": { sfSymbol: "video", materialSymbol: "videocam" },
  // --- editing / typography ---
  "type": { sfSymbol: "textformat", materialSymbol: "text_fields" },
  "bold": { sfSymbol: "bold", materialSymbol: "format_bold" },
  "italic": { sfSymbol: "italic", materialSymbol: "format_italic" },
  "underline": { sfSymbol: "underline", materialSymbol: "format_underlined" },
  "align-left": { sfSymbol: "text.alignleft", materialSymbol: "format_align_left" },
  "wrap-text": { sfSymbol: "text.append", materialSymbol: "wrap_text" },
  "columns": { sfSymbol: "rectangle.split.2x1", materialSymbol: "view_column" },
  "git-commit": { sfSymbol: "circle.and.line.horizontal", materialSymbol: "commit" },
  "diamond": { sfSymbol: "diamond", materialSymbol: "diamond" },
  "align-center": { sfSymbol: "text.aligncenter", materialSymbol: "format_align_center" },
  "align-right": { sfSymbol: "text.alignright", materialSymbol: "format_align_right" },
  "indent": { sfSymbol: "increase.indent", materialSymbol: "format_indent_increase" },
  // --- misc ---
  "shopping-cart": { sfSymbol: "cart", materialSymbol: "shopping_cart" },
  "credit-card": { sfSymbol: "creditcard", materialSymbol: "credit_card" },
  "map-pin": { sfSymbol: "mappin", materialSymbol: "location_on" },
  "globe": { sfSymbol: "globe", materialSymbol: "public" },
  "wifi": { sfSymbol: "wifi", materialSymbol: "wifi" },
  "battery": { sfSymbol: "battery.100", materialSymbol: "battery_full" },
  "moon": { sfSymbol: "moon", materialSymbol: "dark_mode" },
  "sun": { sfSymbol: "sun.max", materialSymbol: "light_mode" },
  "square": { sfSymbol: "square", materialSymbol: "crop_square" },
  "circle": { sfSymbol: "circle", materialSymbol: "circle" },
  // --- behavior-registry vocabulary ---
  "book-open": { sfSymbol: "book", materialSymbol: "menu_book" },
  "calendar-clock": { sfSymbol: "calendar.badge.clock", materialSymbol: "event_note" },
  "circle-dot": { sfSymbol: "circle.inset.filled", materialSymbol: "radio_button_checked" },
  "dollar-sign": { sfSymbol: "dollarsign", materialSymbol: "attach_money" },
  "history": { sfSymbol: "clock.arrow.circlepath", materialSymbol: "history" },
  "image-plus": { sfSymbol: "photo.badge.plus", materialSymbol: "add_photo_alternate" },
  "layers": { sfSymbol: "square.3.layers.3d", materialSymbol: "layers" },
  "layout-dashboard": { sfSymbol: "rectangle.3.group", materialSymbol: "dashboard" },
  "message-square-plus": { sfSymbol: "plus.bubble", materialSymbol: "add_comment" },
  "messages-square": { sfSymbol: "bubble.left.and.bubble.right", materialSymbol: "forum" },
  "mouse-pointer-click": { sfSymbol: "cursorarrow.click", materialSymbol: "touch_app" },
  "package": { sfSymbol: "shippingbox", materialSymbol: "inventory_2" },
  // SF Symbols has no search-with-x glyph; `magnifyingglass` is the nearest.
  "search-x": { sfSymbol: "magnifyingglass", materialSymbol: "search_off" },
  "shield": { sfSymbol: "shield", materialSymbol: "shield" },
  "sparkles": { sfSymbol: "sparkles", materialSymbol: "auto_awesome" },
  "step-forward": { sfSymbol: "forward.end.fill", materialSymbol: "skip_next" },
  "thumbs-up": { sfSymbol: "hand.thumbsup", materialSymbol: "thumb_up" },
  "trending-down": { sfSymbol: "chart.line.downtrend.xyaxis", materialSymbol: "trending_down" },
  "trending-up": { sfSymbol: "chart.line.uptrend.xyaxis", materialSymbol: "trending_up" },
  "user-check": { sfSymbol: "person.crop.circle.badge.checkmark", materialSymbol: "how_to_reg" },
  // SF Symbols has no unlink glyph; `link` is the nearest (Material has `link_off`).
  "arrow-right-circle": { sfSymbol: "arrow.right.circle", materialSymbol: "arrow_circle_right" },
  "atom": { sfSymbol: "atom", materialSymbol: "science" },
  "ban": { sfSymbol: "nosign", materialSymbol: "block" },
  "bookmark-plus": { sfSymbol: "bookmark", materialSymbol: "bookmark_add" },
  "briefcase": { sfSymbol: "briefcase", materialSymbol: "work" },
  "building-2": { sfSymbol: "building.2", materialSymbol: "business" },
  "clipboard-check": { sfSymbol: "checklist", materialSymbol: "assignment_turned_in" },
  "dices": { sfSymbol: "dice", materialSymbol: "casino" },
  "dna": { sfSymbol: "cross.vial", materialSymbol: "biotech" },
  "door-open": { sfSymbol: "door.left.hand.open", materialSymbol: "meeting_room" },
  "feather": { sfSymbol: "pencil.line", materialSymbol: "draw" },
  "file-signature": { sfSymbol: "signature", materialSymbol: "history_edu" },
  "file-up": { sfSymbol: "arrow.up.doc", materialSymbol: "upload_file" },
  "flame": { sfSymbol: "flame", materialSymbol: "local_fire_department" },
  "flask-conical": { sfSymbol: "flask", materialSymbol: "science" },
  "gift": { sfSymbol: "gift", materialSymbol: "card_giftcard" },
  "handshake": { sfSymbol: "person.2", materialSymbol: "handshake" },
  "key-round": { sfSymbol: "key", materialSymbol: "vpn_key" },
  "languages": { sfSymbol: "globe", materialSymbol: "translate" },
  "leaf": { sfSymbol: "leaf", materialSymbol: "eco" },
  "lightbulb": { sfSymbol: "lightbulb", materialSymbol: "lightbulb" },
  "mail-plus": { sfSymbol: "envelope.badge", materialSymbol: "forward_to_inbox" },
  "maximize-2": { sfSymbol: "arrow.up.left.and.arrow.down.right", materialSymbol: "open_in_full" },
  "network": { sfSymbol: "network", materialSymbol: "hub" },
  "presentation": { sfSymbol: "play.rectangle", materialSymbol: "slideshow" },
  "repeat": { sfSymbol: "repeat", materialSymbol: "repeat" },
  "route": { sfSymbol: "point.topleft.down.to.point.bottomright.curvepath", materialSymbol: "route" },
  "ruler": { sfSymbol: "ruler", materialSymbol: "straighten" },
  "scale": { sfSymbol: "scalemass", materialSymbol: "balance" },
  "scroll": { sfSymbol: "scroll", materialSymbol: "receipt_long" },
  "shield-check": { sfSymbol: "checkmark.shield", materialSymbol: "verified_user" },
  "sigma": { sfSymbol: "sum", materialSymbol: "functions" },
  "sticky-note": { sfSymbol: "note.text", materialSymbol: "sticky_note_2" },
  "store": { sfSymbol: "storefront", materialSymbol: "store" },
  "target": { sfSymbol: "scope", materialSymbol: "gps_fixed" },
  "unlink": { sfSymbol: "link", materialSymbol: "link_off" }
};
var ICON_ALIASES = [
  "close",
  "trash",
  "loader",
  "stop",
  "volume",
  "volume-off",
  "refresh",
  "share",
  "sort-asc",
  "sort-desc"
];
function resolveNativeIcon(name) {
  const direct = ICON_NATIVE_MAP[name];
  if (direct) return direct;
  if (ICON_ALIASES.includes(name)) {
    const aliased = ICON_NATIVE_MAP[name];
    if (aliased) return aliased;
  }
  return ICON_FALLBACK;
}

export { ApiError, ICON_ALIASES, ICON_FALLBACK, ICON_NATIVE_MAP, JAZARI_COLORS, apiClient, computeJazariLayout, createCommandSendPump, resolveNativeIcon };
